import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { requireCapability } from '@/lib/route-guards';
import { warm, warmBackground } from '@/api/loaders';
import { audiencesList, campaignsList, productionsList } from '@/api/resources';
import { AudiencesView } from '@/screens/audiences-list';

export const Route = createFileRoute('/audiences/')({
  beforeLoad: requireCapability('audiences_view'),
  // `created` names an audience New Audience just saved, for the list's "created" banner.
  validateSearch: (search: Record<string, unknown>): { created?: string } => ({
    created: typeof search.created === 'string' && search.created ? search.created : undefined,
  }),
  // Blocks on the rows this screen is about; its companions fill in behind.
  loader: ({ context }) => {
    warmBackground(context.queryClient, campaignsList({}), productionsList({}));
    return warm(context.queryClient, audiencesList({}));
  },
  component: Page,
});

function Page() {
  const navigate = useNavigate();
  const { created } = Route.useSearch();
  return (
    <AudiencesView
      flashId={created}
      clearFlash={() => void navigate({ to: '/audiences', search: {}, replace: true })}
    />
  );
}
